import usersReducer from './reducer';
import * as usersActions from './reducer';

export { usersActions };

export default usersReducer;
